var exports = {
  "u": "x112a1f60--fd3bce--section",
};

module.exports = exports;
